<template>
	<div style="width: 100%">
		<div class="px-2">
			<v-text-field v-model="search" class="px-2" append-icon="mdi-magnify" label="Buscar" single-line
				hide-details></v-text-field>
		</div>
		<v-data-table :headers="headers" :items="ofertas" :footer-props="footersProps" :page.sync="page"
			:items-per-page="10" :options.sync="options" :server-items-length="totalEntries"
			:item-class="isComercialCobOrRec ? '' : itemRowBackground" class="elevation-0 px-2"
			:hide-default-footer="loading || IsLoadingTtClienteDetails" :loading="loading || IsLoadingTtClienteDetails">
			<template v-slot:item.atencion.cliente.nombre="{ item }">
				<div class="d-flex align-center">
					<v-tooltip v-if="isUpdatedBy(item)" top :color="item.estado == 'VENDIDO' ? 'success' : 'error'">
						<template v-slot:activator="{ on, attrs }">
							<v-icon left :color="item.estado == 'VENDIDO' ? 'success' : 'error'" dark v-bind="attrs"
								v-on="on">
								{{item.estado == 'VENDIDO' ? 'mdi-cash-plus' : 'mdi-cash-remove'}}
							</v-icon>
						</template>
						<span>{{item.updatedby.nombreCompleto}}</span>
					</v-tooltip>
					<v-tooltip v-if="isOfertaRecomendador(item) && !isComercialCobOrRec" top color="primary">
						<template v-slot:activator="{ on, attrs }">
							<v-icon left color="primary" dark v-bind="attrs" v-on="on">
								mdi-account-voice
							</v-icon>
						</template>
						<span>{{item.atencion.comercial.nombreCompleto}}</span>
					</v-tooltip>
					<div class="font-weight-medium">
						{{
						item.atencion.cliente.nombre
						? item.atencion.cliente.nombre
						: 'Sin asignar'
						}}
					</div>
				</div>
			</template>
			<template v-if="$store.getters['login/hasManagerPermission']" v-slot:item.atencion.comercial="{ item }">
				<div>
					{{ getNombreComercial(item.atencion) }}
				</div>
			</template>
			<template v-slot:item.atencion.fechaContacto="{ item }">
				<div class="font-italic">
					{{ formatDate(item.atencion.fechaContacto) }}
				</div>
			</template>
			<template v-slot:item.atencion.updatedOn="{ item }">
				<div class="font-italic">
					{{ formatDate(item.atencion.updatedOn) }}
				</div>
			</template>
			<template v-slot:item.processed="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-icon
							v-bind="attrs"
							v-on="on"
							:color="
							item.estado === 'VENDIDO'
								? (item.processed ? 'success' : 'warning')
								: 'error'
							"
							dark
						>
							{{
							item.estado === 'VENDIDO'
								? (item.processed ? 'mdi-cash-register' : 'mdi-timer-sand')
								: 'mdi-cancel'
							}}
						</v-icon>
					</template>

					<span v-if="item.estado === 'VENDIDO'">
						{{ item.processed ? 'Tramitada' : 'Pendiente de tramitación' }}
					</span>

					<div v-else class="text-capitalize">
						Oferta {{ item.estado.toLowerCase() }}
					</div>
				</v-tooltip>
			</template>
			<template v-slot:item.actions_vender="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<div v-on="on">
							<v-icon color="success" :disabled="
								loading ||
								IsLoadingTtClienteDetails ||
								isOfertaAntigua(item) ||
								tieneLineasCompletas(item) || ((!hasAdminPermission && cuenta.tipoComercial != 'TIENDA')  && isOfertaRecomendador(item))
							" @click="sellOffer(item)" v-bind="attrs">
								mdi-tag-plus
							</v-icon>
						</div>
					</template>
					<div v-if="tieneLineasCompletas(item)">
						Rellene antes las lineas asocidadas a cada paquete en la
						oferta
					</div>
					<div v-else-if="isComercialRecomendador">
						Usted no tiene permisos para vender
					</div>
					<div v-else>Se puede vender la oferta</div>
				</v-tooltip>
			</template>
			<template v-slot:item.actions_rechazar="{ item }">
				<div>
					<v-icon color="error" :disabled="
						loading ||
						IsLoadingTtClienteDetails ||
						isOfertaAntigua(item) || ((!hasAdminPermission && cuenta.tipoComercial != 'TIENDA') && isOfertaRecomendador(item))
					" @click="rejectOffer(item)" loading>
						mdi-tag-remove
					</v-icon>
				</div>
			</template>
			<template v-slot:item.actions_fecha="{ item }">
				<div>
					<v-icon color="primary" :disabled="
						loading ||
						IsLoadingTtClienteDetails ||
						isOfertaAntigua(item)
					" @click="changeDateAtencion(item.atencion)" loading>
						mdi-calendar
					</v-icon>
				</div>
			</template>
			<template v-slot:item.actions_editar="{ item }">
				<div
					v-if="(isOfertaRecomendador(item) && (item.atencion.comercial.id == cuenta.id || hasAdminPermission))">
					<v-icon :color="
						!tieneLineasCompletas(item)
							? 'success'
							: 'warning'
					" :disabled="
						loading ||
						IsLoadingTtClienteDetails ||
						isOfertaAntigua(item) || item.processed
					" @click="initialiseEditing(item)" loading>
						mdi-pen
					</v-icon>
				</div>
				<v-tooltip v-else-if="(isOfertaRecomendador(item) && (item.atencion.comercial.id != cuenta.id))" bottom>
					<template v-slot:activator="{ on, attrs }">
						<div v-on="on">
							<v-icon :color="
								!tieneLineasCompletas(item)
									? 'success'
									: 'warning'
							" :disabled="
								loading ||
								IsLoadingTtClienteDetails ||
								isOfertaAntigua(item) || (isOfertaRecomendador(item) && (item.atencion.comercial.id != cuenta.id || hasAdminPermission)) || item.processed
							" @click="initialiseEditing(item)" loading>
								mdi-pen
							</v-icon>
						</div>
					</template>
					<div>
						Solo el recomendador que realizo la oferta puede editarla
					</div>
				</v-tooltip>
				<div v-else>
					<v-icon :color="
						!tieneLineasCompletas(item)
							? 'success'
							: 'warning'
					" :disabled="
						loading ||
						IsLoadingTtClienteDetails ||
						isOfertaAntigua(item) || item.processed
					" @click="initialiseEditing(item)" loading>
						mdi-pen
					</v-icon>
				</div>

			</template>
			<template v-slot:item.actions_seguimiento_paquetes="{ item }">
				<v-row no-gutters>
					<v-col cols="12" md="6">
						<v-row justify="end">
							<v-tooltip right :color="getColorPackage(item)">
								<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on" :color="getColorPackage(item)" :disabled="
										loading ||
										IsLoadingTtClienteDetails ||
										isOfertaAntigua(item) ||
										notYoigoOffer(item)
									" @click="getSeguimientoPaquetes(item)">
										{{
										tieneEstadoPaquetes(item)
										? 'mdi-package-variant-closed'
										: 'mdi-package-variant'
										}}
									</v-icon>
								</template>
								<span v-if="!notYoigoOffer(item)" class="overline">{{ numPaquetesEstado(item, 'ACTIVO')
								}}/{{
									item.paquetes.length
									}}</span>
							</v-tooltip>

							<!-- <v-icon
                                v-if="!notYoigoOffer(item)"
                                :color="getColorPackage(item)"
                                :disabled="
                                    loading ||
                                    IsLoadingTtClienteDetails ||
                                    isOfertaAntigua(item)
                                "
                            >
                                mdi-circle
                            </v-icon> -->
						</v-row>
					</v-col>
				</v-row>
			</template>

			<template v-slot:item.showOffer="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<div v-on="on">
							<v-btn color="#2c3a5c" v-bind="attrs" :disabled="
								loading ||
								IsLoadingTtClienteDetails ||
								isOfertaAntigua(item)
							" :loading="
								isLoadingHtmlOffer &&
								offer &&
								item.id == offer.id
							" @click="generateHtmlOffer(item)" icon>
								<v-icon>mdi-eye</v-icon>
							</v-btn>
						</div>
					</template>
					<div class="text-capitalize">
						<div v-if="!isOfertaAntigua(item)">Ver oferta</div>
						<div v-else>
							<div v-if="item.paquetes.length == 0">
								Sin productos
							</div>
							<div v-else>
								<div v-for="paquete in item.paquetes">
									{{
									formatUnidadVenta(
									paquete.unidadVentaDeprecated
									)
									}}
								</div>
							</div>
						</div>
					</div>
				</v-tooltip>
			</template>
			<template v-slot:item.info="{ item }">
				<v-tooltip bottom v-if="
					!item.paquetes.length ||
					item.paquetes.some(
						({ unidadVentaDeprecated }) =>
							unidadVentaDeprecated != null
					)
				">
					<template v-slot:activator="{ on, attrs }">
						<v-icon v-bind="attrs" v-on="on">
							mdi-clock-alert
						</v-icon>
					</template>
					<span> Antigua oferta </span>
				</v-tooltip>
			</template>
		</v-data-table>
		<!-- <PDFView :offer="offer" /> -->
	</div>
</template>
    
    <script>
import { mapActions, mapState, mapGetters } from 'vuex';
import axios from 'axios';
// import PDFView from '@/components/PDFView/PDFView.vue';
import FormAtencion from '@/components/AreaPersonal/Calculadora/FormAtencion.vue';
import { objectSnakeToCamelCase } from '@/util/libUtil.js';

export default {
	components: {
		// PDFView,
		FormAtencion,
	},
	data: () => ({
		headers: [
			{
				text: 'Cliente',
				value: 'atencion.cliente.nombre',
				sortable: false,
			},
			{
				text: 'Fecha contacto',
				value: 'atencion.fechaContacto',
				align: 'center',
				sortable: false,
			},
			{
				text: 'Actualizado',
				value: 'atencion.updatedOn',
				align: 'center',
				sortable: false,
			},
			{
				text: 'Ver oferta',
				value: 'showOffer',
				align: 'center',
				sortable: false,
			},
			{
				text: 'Tramitada',
				value: 'processed',
				align: 'center',
				sortable: false,
			}
		],
		footersProps: {
			disableItemsPerPage: false,
			itemsPerPageOptions: [10],
		},
		ofertas: [],
		options: {},
		page: 1,
		totalEntries: 0,
		isLoadingHtmlOffer: false,
		offer: null, // la oferta a la que se le ha dado click para ver, o editar
		isOpenViewDialog: false,
		search: null,
	}),
	props: {
		filterOffers: Object,
		showChangeState: Number,
		estado: String,
	},
	computed: {
		cuenta() {
			return JSON.parse(localStorage.getItem('cuenta'));
		},
		opciones() {
			return JSON.parse(localStorage.getItem('opciones'));
		},
		loading: {
			get() {
				return this.$store.state.areaPersonal.calculadora
					.isLoadingOfertas;
			},
			set(value) {
				this.$store.commit(
					'areaPersonal/calculadora/isLoadingOfertas',
					value
				);
			},
		},
		...mapState('areaPersonal/calculadora', {
			currentDate: (state) => state.date,
			ofertaHtml: (state) => state.ofertaHtml,
			selectedComercial: (state) => state.selectedComercial,
			isAlreadyUpdated: (state) =>
				state.dateAtencionForm.isAlreadyUpdated,
			isOpenAtencion: (state) => state.dateAtencionForm.isOpen,
			father: (state) => state.dateAtencionForm.father,
			actualTab: (state) => state.actualTab,
		}),
		// ...mapState('util', {
		// 	opciones: (state) => state.opciones,
		// }),
		...mapState('orders', {
			isOpenOrders: (state) => state.isOpenOrders,
			isUpdatedOrder: (state) => state.order.isUpdatedOrder,
		}),
		...mapState('teletrabajo', {
			comerciales: (state) => state.Comerciales,
			IsLoadingTtClienteDetails: (state) =>
				state.CompleteViewTtForm.details.isLoading,
			DetailForm: (state) => state.CompleteViewTtForm.details.form,
		}),
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
			hasManagerPermission: 'hasManagerPermission',
			isComercialCobOrRec: 'isComercialCobOrRec',
			isComercialRecomendador: 'isComercialRecomendador',
			hasComercialPermission: 'hasComercialPermission',
		}),
		encodedEstado() {
			let keys = this.opciones
				? this.opciones.oferta.estado.map(({ encoded }) => encoded)
				: [];
			let index = [...Array(keys.length).keys()];

			var result = {};
			keys.forEach((key, i) => (result[key] = index[i]));

			return result;
		},
	},
	methods: {
		isUpdatedBy(item) {
            return item.updatedby != null && item.updatedby.comercial != this.cuenta.id;
        },
		isOfertaRecomendador(item) {
			return item.atencion.comercial.tipoComercial == 'RECOMENDADOR';
		},
		itemRowBackground: function (item) {
			if (this.isOfertaRecomendador(item)) {
				return 'azul';
			}
		},
		async initialiseEditing(item) {
			this.$store.commit('configuradorOferta/configuratorType', 'EDIT');

			this.$store.commit(
				'teletrabajo/IsOpenCompleteViewTtFormDialog',
				false
			);

			let atencion = objectSnakeToCamelCase(
				await this.fetchAtencion(item.atencion.id)
			);

			// Antes de editar la oferta obtenemos el installment de el cacharro si tiene cacharro y es porta y se setea para el pricetotal
			// atencion.servicio.paquetes.forEach(async (paquete) => {
			//     if (paquete.cacharro && paquete.tipoVenta == 'PORTA') {
			//         paquete.cacharro.installment = await this.$store.dispatch(
			//             'configuradorOferta/fetchSpecificInstallments',
			//             {
			//                 idTarifa: paquete.tarifa.id,
			//                 idCacharro: paquete.cacharro.id,
			//             }
			//         );
			//     }
			// });

			// atencion.servicio.paquetes.forEach(async (paquete) => {
			//     paquete.cacharro.installment = await this.$store.dispatch(
			//         'configuradorOferta/fetchSpecificInstallments',
			//         {
			//             idTarifa: paquete.tarifa.id,
			//             idCacharro: paquete.cacharro.id,
			//         }
			//     );
			// });

			this.$router.push({
				name: 'OfferConfigurator',
				params: { id: atencion.cliente.id },
			});

			setTimeout(() => {
				this.$store.dispatch('configuradorOferta/initialiseEditing', atencion);
			}, 1000);
		},

		getSeguimientoPaquetes(item) {
			this.$emit(
				'offerEmit',
				JSON.parse(
					JSON.stringify({
						nameComponent: 'OrdersView',
						data: {
							packages: item.paquetes,
							updatedOn: item.atencion.updatedOn,
						},
					})
				)
			);
			// Por ahora solo obtenemos las ordenes de Yoigo, por eso forzamos a que busque en frontal
			// declarandole el operador, y que no obtenga el isp actual del cliente, que podría ser otro
			this.fetchTtClienteDetailed({
				idTtCliente: item.atencion.cliente.id,
				operator: 'Yoigo',
			}).then(() => {
				if (
					!(
						this.DetailForm &&
						Object.keys(this.DetailForm).length === 0 &&
						Object.getPrototypeOf(this.DetailForm) ===
							Object.prototype
					)
				) {
					setTimeout(() => {
						this.$store.commit('orders/isOpenOrders', true);
					}, 100);
				}
			});
		},
		...mapActions({
			fetchObjetivo: 'areaPersonal/calculadora/fetchObjetivo',
			fetchOfertas: 'areaPersonal/calculadora/fetchOfertas',
			updateOffer: 'areaPersonal/calculadora/updateOffer',
			fetchHtmlOffer: 'areaPersonal/calculadora/fetchHtmlOffer',
			fetchAtencion: 'areaPersonal/calculadora/fetchAtencion',
			fetchSpecificInstallments:
				'configuradorOferta/fetchSpecificInstallments',
			fetchTtClienteDetailed: 'teletrabajo/fetchTtClienteDetailed',
		}),
		getNombreComercial(item) {
			let nombre = 'Sin asignar';
			if (item.comercial) {
				if (this.comerciales) {
					let comercial_find = this.comerciales.find(
						(comercial) => comercial.id === item.comercial
					);
					if (comercial_find) {
						nombre = comercial_find.nombreCompleto;
					}
				}
			}
			return nombre;
		},
		formatDate(date) {
			let mondate = new Date(date);
			let options = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				second: 'numeric',
				hour12: false,
				timeZone: 'Europe/Madrid',
			};
			return new Intl.DateTimeFormat('es-ES', options).format(mondate);
		},
		formatHour(date) {
			let mondate = new Date(date);
			let hours =
				mondate.getHours().toString().length > 1
					? mondate.getHours()
					: '0' + mondate.getHours();
			let minutes =
				mondate.getMinutes().toString().length > 1
					? mondate.getMinutes()
					: '0' + mondate.getMinutes();
			let seconds =
				mondate.getSeconds().toString().length > 1
					? mondate.getSeconds()
					: '0' + mondate.getSeconds();

			return `${hours}:${minutes}:${seconds}`;
		},
		changeDateAtencion(atencion) {
			let dateAtencionForm = {
				father: 'OFERTA',
				isAlreadyUpdated: false,
				isOpen: true,
				isEditing: false,
				isLoading: false,
				form: JSON.parse(JSON.stringify(atencion)),
			};

			this.$store.commit(
				'areaPersonal/calculadora/dateAtencion',
				dateAtencionForm
			);
		},
		generateHtmlOffer(offer) {
			this.$emit(
				'offerEmit',
				JSON.parse(
					JSON.stringify({
						nameComponent: 'PDFView',
						data: offer,
					})
				)
			);

			// this.offer = JSON.parse(JSON.stringify(offer));
			// let PDFView = {
			//     isLoadingHtmlOffer: true,
			//     isOpenViewDialog: true,
			//     ofertaHtml: '',
			// };

			// this.$store.commit('util/PDFView', PDFView);
		},
		async update() {
			if (this.encodedEstado[this.estado] == this.actualTab) {
				this.loading = true;
				try {
					let params = {
						...this.filterOffers,
						...this.options,
					};

					// Check if params have a key
					if ('itemsPerPage' in params) {
						if (this.hasManagerPermission && this.selectedComercial)
							params.comercial = this.selectedComercial.id;
						if (this.search) params.search = this.search;
						let data = await this.fetchOfertas(params);
						this.ofertas = data.results;
						this.totalEntries = data.count;
					}
				} catch (err) {
					console.log(err.message);
				}
				this.loading = false;
				// setTimeout(() => (this.loading = !this.loading), 0);
			}
		},
		async sellOffer(offer) {
			let params = { id: offer.id, estado: 'VENDIDO' }
			// If offer is type recomendador and cuenta actual is different id to offer comercial
			if (this.hasComercialPermission && this.cuenta.tipoComercial == 'TIENDA' && this.isOfertaRecomendador(offer)){
				params['updatedby_comercial'] = this.cuenta.id;
			}

			await this.updateOffer(params);
			this.update();

			if (this.hasManagerPermission && this.selectedComercial) {
				this.fetchObjetivo({ comercialId: this.selectedComercial.id });
			} else if (!this.hasManagerPermission) {
				this.fetchObjetivo({});
			}
		},
		async rejectOffer(offer) {
			let params = { id: offer.id, estado: 'RECHAZADO' }
			// If offer is type recomendador and cuenta actual is different id to offer comercial
			if (this.hasComercialPermission && this.cuenta.tipoComercial == 'TIENDA' && this.isOfertaRecomendador(offer)){
				params['updatedby_comercial'] = this.cuenta.id;
			}

			await this.updateOffer(params);
			this.update();

			if (this.hasManagerPermission && this.selectedComercial) {
				this.fetchObjetivo({ comercialId: this.selectedComercial.id });
			} else if (!this.hasManagerPermission) {
				this.fetchObjetivo({});
			}
		},
		isOfertaAntigua(oferta) {
			return (
				!oferta.paquetes.length ||
				oferta.paquetes.some(
					({ unidadVentaDeprecated }) => unidadVentaDeprecated != null
				)
			);
		},
		notYoigoOffer(oferta) {
			return (
				oferta.paquetes.length &&
				oferta.paquetes.some(
					({ tarifa }) =>
						tarifa.operator != 'YOIGO' && tarifa.operator != 'DBL'
				)
			);
		},
		getColorPackage(oferta) {
			const paquetesSinSVA = oferta.paquetes.filter(
				({ tipoLinea }) => tipoLinea != 'LINEA_ADICIONAL_SVA'
			);

			if (paquetesSinSVA.length) {
				let color = '#2c3a5c';
				if (
					paquetesSinSVA.some(
						({ additionalinfo }) =>
							additionalinfo?.state === 'CANCELADO'
					)
				) {
					color = 'error';
				} else if (
					paquetesSinSVA.some(
						({ additionalinfo }) =>
							additionalinfo?.state === 'VUELO'
					)
				) {
					color = 'warning';
				} else if (
					paquetesSinSVA.every(
						({ additionalinfo }) =>
							additionalinfo?.state === 'ACTIVO'
					)
				) {
					color = 'success';
				}
				return color;
			}
		},
		tieneLineasCompletas(oferta) {
			return !oferta.paquetes.every(({ lineasAsociadas }) =>
				lineasAsociadas ? lineasAsociadas.length > 0 : false
			);
		},
		tieneEstadoPaquetes(oferta) {
			return !oferta.paquetes.every(({ additionalinfo }) =>
				additionalinfo ? true : false
			);
		},
		numPaquetesEstado(oferta, estadoSearch) {
			return oferta.paquetes.filter(
				({ additionalinfo }) => additionalinfo?.state == estadoSearch
			).length;
		},
		formatUnidadVenta(unidadVenta) {
			return unidadVenta.replaceAll(/_/g, ' ');
		},
		resizeIframe(iframe) {
			console.log('hola');
		},
	},
	watch: {
		// filterOffers: {
		//     immediate: true,
		//     handler: async function (newVal, oldVal) {
		//         if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
		//             return;
		//         }

		//         this.update();
		//         this.options.page = 1;
		//     },
		// },
		options: {
			immediate: true,
			handler: async function (newVal, oldVal) {
				if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
					return;
				}

				this.update();
			},
		},

		isOpenOrders: {
			immediate: true,
			handler: async function (newVal, oldVal) {
				if (oldVal && !newVal && this.isUpdatedOrder) {
					this.update().then(() =>
						this.$store.commit('orders/isUpdatedOrder', false)
					);
				}
			},
		},

		// showChangeState: {
		//     immediate: true,
		//     handler: function (showChangeState) {
		//         let infoHeader = {
		//             text: 'Información',
		//             value: 'info',
		//             align: 'center',
		//         };

		//         if (this.headers.some(({ value }) => value === 'info'))
		//             this.headers.push(infoHeader);
		//     },
		// },
		showChangeState() {
			this.update();
		},
		currentDate() {
			this.update();
		},
		selectedComercial: {
			immediate: true,
			handler: function (selectedComercial) {
				// this.options = {};
				this.page = 1;
				this.update();
			},
		},
		search(newVal, oldVal) {
			let prev = newVal;
			this.page = 1;
			setTimeout(() => {
				if (prev == this.search) this.update();
			}, 200);
		},
		isAlreadyUpdated() {
			if (this.father == 'OFERTA' && this.isAlreadyUpdated) {
				this.$store.commit(
					'areaPersonal/calculadora/dateAtencionIsAlreadyUpdated',
					false
				);
			}
			if (!this.isOpenAtencion) this.update();
		},
	},
	mounted() {
		if (this.$store.getters['login/hasManagerPermission']) {
			this.headers.splice(1, 0, {
				text: 'Comercial',
				value: 'atencion.comercial.nombreCompleto',
				sortable: false,
				align: 'center',
			});
		}
		if (this.showChangeState == 1) {
			if (
				!this.headers.some(
					({ text }) => text === 'Vender' || text === 'Rechazar'
				)
			) {
				this.headers.push(
					{
						text: 'Vender',
						value: 'actions_vender',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Rechazar',
						value: 'actions_rechazar',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Cambiar fecha',
						value: 'actions_fecha',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Editar oferta',
						value: 'actions_editar',
						align: 'center',
						sortable: false,
					}
				);
			}
		}

		if (this.showChangeState == 0) {
			if (!this.headers.some(({ text }) => text === 'Rechazar')) {
				this.headers.push(
					{
						text: 'Rechazar',
						value: 'actions_rechazar',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Cambiar fecha',
						value: 'actions_fecha',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Editar oferta',
						value: 'actions_editar',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Estado paquetes',
						value: 'actions_seguimiento_paquetes',
						align: 'center',
						sortable: false,
					}
				);
			}
		}

		if (this.showChangeState == 2) {
			if (!this.headers.some(({ text }) => text === 'Vender')) {
				this.headers.push(
					{
						text: 'Vender',
						value: 'actions_vender',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Cambiar fecha',
						value: 'actions_fecha',
						align: 'center',
						sortable: false,
					},
					{
						text: 'Editar oferta',
						value: 'actions_editar',
						align: 'center',
						sortable: false,
					}
				);
			}
		}
	},
};
</script>

<style scoped>
.azul {
	background-color: #baccff;
}
</style>